<div class="notification_Icon dropdown-container" appDropDown>
  <div class="dropdown-toggler d-flex align-items-center"
    (click)="notificationList_opened=true">
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_16161_33040)">
      <path d="M14.999 28.568C15.5239 28.5559 16.0277 28.3585 16.4211 28.0108C16.8146 27.6631 17.0724 27.1874 17.149 26.668H12.7656C12.8444 27.2016 13.1142 27.6884 13.525 28.0379C13.9359 28.3874 14.4596 28.5758 14.999 28.568Z" fill="#ACACB9"/>
      <path d="M27.0891 23.193C26.2855 22.4766 25.5819 21.6553 24.9974 20.7513C24.3592 19.5034 23.9768 18.1407 23.8724 16.743V12.6263C23.869 12.1263 23.8244 11.6273 23.7391 11.1346C23.0832 11.0035 22.4528 10.7671 21.8724 10.4346C22.0936 11.147 22.206 11.8887 22.2057 12.6346V16.7513C22.3079 18.4563 22.7769 20.1192 23.5807 21.6263C24.1561 22.538 24.8387 23.3773 25.6141 24.1263H4.2724C5.04774 23.3773 5.73039 22.538 6.30573 21.6263C7.10957 20.1192 7.57859 18.4563 7.68073 16.7513V12.6263C7.67634 11.6619 7.86224 10.7061 8.22776 9.81357C8.59329 8.92108 9.13128 8.10947 9.81091 7.42519C10.4905 6.74091 11.2985 6.19741 12.1885 5.82581C13.0784 5.45422 14.033 5.26182 14.9974 5.25964C16.4089 5.26076 17.7887 5.67818 18.9641 6.45964C18.8345 5.98379 18.7618 5.49427 18.7474 5.0013V4.4763C17.8773 4.04827 16.9425 3.76671 15.9807 3.64297V2.59297C15.9807 2.29792 15.8635 2.01495 15.6549 1.80631C15.4463 1.59768 15.1633 1.48047 14.8682 1.48047C14.5732 1.48047 14.2902 1.59768 14.0816 1.80631C13.8729 2.01495 13.7557 2.29792 13.7557 2.59297V3.68464C11.6022 3.98843 9.63121 5.06109 8.20675 6.70458C6.78229 8.34807 6.0005 10.4514 6.00573 12.6263V16.743C5.90136 18.1407 5.51888 19.5034 4.88073 20.7513C4.30646 21.6533 3.61422 22.4744 2.8224 23.193C2.73351 23.2711 2.66226 23.3672 2.61341 23.475C2.56456 23.5827 2.53921 23.6996 2.53906 23.818V24.9513C2.53906 25.1723 2.62686 25.3843 2.78314 25.5406C2.93942 25.6968 3.15138 25.7846 3.3724 25.7846H26.5391C26.7601 25.7846 26.972 25.6968 27.1283 25.5406C27.2846 25.3843 27.3724 25.1723 27.3724 24.9513V23.818C27.3722 23.6996 27.3469 23.5827 27.298 23.475C27.2492 23.3672 27.178 23.2711 27.0891 23.193Z" fill="#ACACB9"/>
      <path d="M25.0026 9.16536C27.3038 9.16536 29.1693 7.29988 29.1693 4.9987C29.1693 2.69751 27.3038 0.832031 25.0026 0.832031C22.7014 0.832031 20.8359 2.69751 20.8359 4.9987C20.8359 7.29988 22.7014 9.16536 25.0026 9.16536Z" fill="#FAB91A"/>
      </g>
      <defs>
      <clipPath id="clip0_16161_33040">
      <rect width="30" height="30" fill="white"/>
      </clipPath>
      </defs>
    </svg>

    <!-- <span class="num">{{totalUnreadNotifications>99 ?'99+':totalUnreadNotifications}}</span> -->

  </div>

  <div class="custom-dropdown-menu dropdown-inner-menu">
    @if (notificationList_opened) {
    <div class="notification_list p-0"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="notificationListModel.perPage"
      (scrolled)="getNextPage()"
      [fromRoot]="true">
      <!-- <ng-container *ngIf='!loading'> -->
      <div *ngIf="notificationList">
        <ng-container *ngFor="let item of notificationList">
          <a class="notification_record border-start" [href]="item.web_site_url+''+item.web_link"
            [ngClass]="{'anchor-disable' : !item.web_link,'can_nav':item.web_link}">
            <!-- <div class="image">
              <img *ngIf="item?.image" [src]="item?.image">
              <img *ngIf="!item.image" style="width: 50% !important; height: 50% !important;"
                src="./assets/images/icons/notification.png">
            </div> -->
            <div class="content">
              <div class="title">{{item?.message}}</div>
              <div class="description" *ngIf="item?.sub_title">
                {{item?.sub_title}}
              </div>
              <div class="date">
                <span class="day">{{item.created_at | timeAgo}}</span>
                {{item?.created_at | date :'d MMMM y - h:mm a' }}
              </div>
            </div>
          </a>
        </ng-container>
      </div>

      <div class="dataLoading py-3" *ngIf='loading'>
        <div class="spinner-border"></div>
      </div>

      <div class="py-5" *ngIf="!notificationList?.length && !loading">
        <empty-state [title]='"general.There is no notifications" | translate'></empty-state>
      </div>

    </div>
    }
  </div>

  <div class="overlayLayer" (click)="notificationList_opened=false"></div>
</div>
